var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.055 24.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 578"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.541 11.668H4.565a.402.402 0 1 0 0 .805h7.976a.402.402 0 0 0 0-.805Z",
    "data-name": "Caminho 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.541 9.547H4.565a.403.403 0 0 0 0 .806h7.976a.403.403 0 0 0 0-.806Z",
    "data-name": "Caminho 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.541 7.425H4.565a.403.403 0 1 0 0 .806h7.976a.403.403 0 0 0 0-.806Z",
    "data-name": "Caminho 52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.676 2.578H13.4a1.732 1.732 0 0 0-1.665-1.235h-1.4a1.877 1.877 0 0 0-3.6 0h-1.4A1.733 1.733 0 0 0 3.67 2.578H.394a.413.413 0 0 0-.4.4v21.567a.413.413 0 0 0 .4.4h16.247a.413.413 0 0 0 .4-.4V2.981a.36.36 0 0 0-.365-.403ZM5.344 2.121h1.718a.408.408 0 0 0 .4-.376 1.08 1.08 0 0 1 2.148 0 .408.408 0 0 0 .4.376h1.718a.913.913 0 0 1 .913.859v.376H4.424V2.98a.932.932 0 0 1 .92-.858Zm10.93 22.021H.805V3.388h2.793v.4a.413.413 0 0 0 .4.4h9.05a.413.413 0 0 0 .4-.4v-.4h2.82Z",
    "data-name": "Caminho 54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogs);
export default __webpack_public_path__ + "static/media/icon-logs.f991244fbec15d1f0ceac6d0eda10b05.svg";
export { ForwardRef as ReactComponent };